import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProject } from '../../../classes/customer-project.class';
import { User } from '../../../classes/user.class';
import { CodaltComponent } from '../../../codalt.component';
import { ApiResponse } from '../../../services/api/api.service';
import { CustomerProjectService } from '../../../services/customer-project.service';

@Component({
    selector: 'app-add-townproject-modal',
    templateUrl: './add-customer-project-modal.component.html',
    standalone: false,
})
export class AddCustomerProjectModalComponent extends CodaltComponent implements OnInit {
    customerProject: CustomerProject;

    customerProjects: {
        id: number;
        name: string;
        customer_id: number;
        customer_name: string;
    }[];

    constructor(
        public dialogRef: MatDialogRef<AddCustomerProjectModalComponent>,
        private confirmDialogService: ConfirmDialogService,
        private customerProjectService: CustomerProjectService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            user: User;
        }
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.customerProjectService.getConsumerProjects().subscribe(res => {
                const projectIds = this.data.user.customer_projects.map(p => p.id);
                this.customerProjects = res.filter(p => projectIds.indexOf(p.id) === -1);
            })
        );
    }

    addCustomerProject() {
        this.subscriptions.add(
            this.customerProjectService
                .follow(this.customerProject.id, this.data.user.id)
                .subscribe((result: ApiResponse<User>) => {
                    if (result.success) {
                        this.dialogRef.close(result.data);
                    } else {
                        this.failed();
                    }
                })
        );
    }

    failed() {
        this.confirmDialogService
            .confirm({
                title: 'Project toevoegen mislukt',
                text: 'Het is niet gelukt om dit project toe te voegen.',
                confirm: 'Sluiten',
                cancel: null,
            })
            .then(() => {
                this.dialogRef.close();
            });
    }
}
